export default __webpack_public_path__ + "static/media/xmark.aa2c6166.svg";